import React from 'react'
import { change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'moment/locale/pt-br'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { alterarTipoAjusteItinerarioEmLote } from '../../actions/itinerario/alterarTipoAjusteItinerarioEmLote'
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import { tiposConfiguracoesPreco, tiposConfiguracoesPrecoPrioritario } from '../../util/constantsUtil';
import DiasSemanaSelector from './DiasSemanaSelector'; // ajusta o caminho conforme a pasta
import FieldsetConfiguracaoPreco from './FieldsetConfiguracaoPreco';


registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');


export class ModalAlteracaoTipoAjusteItinerarioEmLote extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.state = { dataInicio: null, dataFim: null, diasSelecionados: [] }
    }

    montarParametroItinerario(values) {
        let tipoAjuste = this.props.exibirAjuste && values.tipoAjusteItinerario ? values.tipoAjusteItinerario.value : null;
        let valorAjuste = this.props.exibirAjuste && values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
        let tipoConfiguracaoPreco = null;
        let horaPartidaRegra = null;
        let quantidadePoltronasRegra = null;
        let tipoConfiguracaoPrecoPrioritario = null;

        if (values.exibirAjuste) {
            tipoAjuste = values.tipoAjusteItinerario.value;
            tipoConfiguracaoPreco = values.tipoConfiguracaoPreco.value;
            valorAjuste = values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
            if (tipoConfiguracaoPreco === 'DATA_PARTIDA') {
                horaPartidaRegra = values.horaPartidaRegra;
            }
            if (tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_CADA' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_ATE_NUMERO') {
                quantidadePoltronasRegra = values.quantidadePoltronasRegra;
            }
            
        }
        if (values.exibirAjustePrioritario) {
            tipoConfiguracaoPrecoPrioritario = values.tipoConfiguracaoPrecoPrioritario ? values.tipoConfiguracaoPrecoPrioritario.value : 'POR_USUARIO'
        } else {
            this.props.limparPricePorUsuario();
        }
        return {
            dataInicio: moment(this.state.dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(this.state.dataFim).format('YYYY-MM-DD'),
            empresaId: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            valorAjuste,
            tipoAjuste,
            tipoConfiguracaoPreco,
            horaPartidaRegra,
            quantidadePoltronasRegra,
            diasSelecionados: this.state.diasSelecionados ? this.state.diasSelecionados: [],
            tipoConfiguracaoPrecoPrioritario,
            pricePorUsuarioEmpresa: values.exibirAjustePrioritario ? this.props.vendedoresSelecionados.map(it => {
                return {
                    tipoAjuste: it.tipoAjusteItinerario.value,
                    valorAjuste: it.valorAjuste,
                    tipoConifguracaoPreco: it.tipoConfiguracaoPreco ? it.tipoConfiguracaoPreco.value : 'POR_USUARIO',
                    usuarioId: it.id,
                }
            }) : []

        }
    }

    fecharModal() {
        $('#modalAlteracaoTipoAjusteItinerarioEmLote')
            .modal('hide');
        $('#modalAlteracaoTipoAjusteItinerarioEmLote')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values);
        this.props.alterarTipoAjusteItinerarioEmLote(parametros)
            .then(() => {
                showSuccessMsg('Operação realizada com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios();
            })
    }


    limparFormulario() {
        this.props.reset('formularioAlteracaoTipoAjustePorPeriodo');
        this.setState({ dataInicio: null, dataFim: null });
        this.props.limparPricePorUsuario();
    }


    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({ dataInicio: data, dataFim: null })
        } else {
            this.setState({ data, dataFim: data })
        }
    }


    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 5)
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    handleExibirCamposAjusteValor(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                'valorAjuste', '');
            this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                'tipoAjusteItinerario', '');
        }
        this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
            'exibirAjuste', evento.target.value);
    }
    
    handleExibirCamposAjusteValorPrioritario(evento) {
            if (evento.target.value) {
                this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                    'exibirAjustePrioritario', '');
                this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                    'tipoAjusteItinerarioPrioritario', '');
            }
            this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                'exibirAjustePrioritario', evento.target.value);
    }

    exibirUsuariosVendedoresSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr className='text-center'>
                    <th colSpan='5'>Vendedores</th>
                </tr>
                <tr>
                    <th>ID</th>
                    <th>Desconto/Acréscimo</th>
                    <th>Valor(%)</th>
                    <th>Descricao</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {!this.props.vendedoresSelecionados || this.props.vendedoresSelecionados.length === 0 ?
                    <tr className="alert alert-warning text-center mt-4" role="alert">
                        <td colSpan='5'>Nenhum vendedor foi
                            cadastrado.
                        </td>
                    </tr>
                    :
                    this.props.vendedoresSelecionados
                        .map((vendedor) => <tr key={vendedor.id}>
                            <td>
                                {vendedor.id}
                            </td>                            
                            <td>
                                {vendedor.tipoAjusteItinerario.label}
                            </td>
                            <td>
                                {vendedor.valorAjuste}
                            </td>
                            <td>
                                {vendedor.vendedor.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div
                                    onClick={() => this.props.removerUsuarioVendedor(vendedor.id)}
                                    >Remover
                                </div>
                            </td>
                        </tr>)}
            </tbody>
        </table>        
    }
    
    adicionarPricePorUsuario(event) {
        event.preventDefault();        
        if (!this.props.valorAjustePrioritario) {
            showAlertMsg('Informe o valor.');
            return;
        }
        if (!this.props.tipoAjusteItinerarioPrioritario) {
            showAlertMsg('Informe o desconto/acréscimo.');
            return;
        }
        if (!this.props.vendedores) {
            showAlertMsg('Informe o usuário.');
            return;
        }
        const obj = {id: this.props.vendedores.value, vendedor: this.props.vendedores, valorAjuste: this.props.valorAjustePrioritario, 
                    tipoAjusteItinerario: this.props.tipoAjusteItinerarioPrioritario, tipoConfiguracaoPreco: this.props.tipoConfiguracaoPrecoPrioritario };
        
        this.props.adicionarPricePorUsuario(obj);
        this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
            'vendedores', null);        
    }


    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalAlteracaoTipoAjusteItinerarioEmLote' role='dialog'
                aria-labelledby='modalAlteracaoTipoAjusteItinerarioEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">local_offer</i>
                                <span className="vx-modal-title">Alterar desconto/acréscimo em lote</span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <form id="form-alterar-tipo-ajuste-em-lote" onSubmit={handleSubmit(this.submit)}>
                                <fieldset className="scheduler-border">
                                    <div className="col-12 col-sm-4 col-md-4 mt-2">
                                          <label>Opera em quais dias da semana?</label>
                                          <DiasSemanaSelector
                                            diasSelecionados={this.state.diasSelecionados}
                                            onChange={(novosDias) => this.setState({ diasSelecionados: novosDias })}
                                          />
                                    </div>
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Período de alteração</legend>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data de início</label>
                                        {this.exibirCalendario(true)}
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data fim</label>
                                        {this.exibirCalendario()}
                                    </div>
                                </fieldset>
                                
                                <FieldsetConfiguracaoPreco
                                    exibirAjuste={this.props.exibirAjuste}
                                    exibirAjustePrioritario={this.props.exibirAjustePrioritario}
                                    tipoConfiguracaoPreco={this.props.tipoConfiguracaoPreco}
                                    quantidadePoltronasRegra={this.props.quantidadePoltronasRegra}
                                    tipoConfiguracaoPrecoPrioritario={this.props.tipoConfiguracaoPrecoPrioritario}
                                    quantidadePoltronasRegraPrioritario={this.props.quantidadePoltronasRegraPrioritario}
                                    tiposConfiguracoesPreco={tiposConfiguracoesPreco}
                                    tiposConfiguracoesPrecoPrioritario={tiposConfiguracoesPrecoPrioritario}
                                    usuariosVendedores={this.props.usuariosVendedores}
                                    vendedoresSelecionados={this.props.vendedoresSelecionados}
                                    onToggleAjuste={e => this.handleExibirCamposAjusteValor(e)}
                                    onToggleAjustePrioritario={e => this.handleExibirCamposAjusteValorPrioritario(e)}
                                    onAdicionarPricePorUsuario={e => this.adicionarPricePorUsuario(e)}
                                    onRemoverUsuarioVendedor={id => this.props.removerUsuarioVendedor(id)}
                                />
                            </form>
                        </div>
                        <div className="vx-modal-footer">
                            <button type="submit" form="form-alterar-tipo-ajuste-em-lote"
                                disabled={invalid || submitting || !this.state.dataInicio || !this.state.dataFim}
                                className="vx-btn-primary">
                                <i className="material-icons" style={{ fontSize: '16px' }}>save</i> Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            tipoConfiguracaoPreco: { label: 'Normal', value: 'NORMAL' }
        },
        exibirAjuste: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'exibirAjuste'),
        exibirAjustePrioritario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'exibirAjustePrioritario'),
        vendedores: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'vendedores'),
        valorAjuste: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'valorAjuste'),
        tipoAjusteItinerario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'tipoAjusteItinerario'), 
        tipoConfiguracaoPreco: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'tipoConfiguracaoPreco'),
        horaPartidaRegra: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'horaPartidaRegra'),
        quantidadePoltronasRegra: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'quantidadePoltronasRegra'),
        tipoAjusteItinerarioPrioritario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'tipoAjusteItinerarioPrioritario'),
        valorAjustePrioritario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'valorAjustePrioritario'),
        tipoConfiguracaoPrecoPrioritario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'tipoConfiguracaoPrecoPrioritario'),
        horaPartidaRegraPrioritario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'horaPartidaRegraPrioritario'),
        quantidadePoltronasRegraPrioritario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'quantidadePoltronasRegraPrioritario'),
        empresaSelecionada: state.empresaSelecionada,
        rotaSelecionada: state.rotaSelecionada,
        usuariosVendedores: state.usuariosVendedores

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        alterarTipoAjusteItinerarioEmLote,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlteracaoTipoAjustePorPeriodo',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalAlteracaoTipoAjusteItinerarioEmLote));
